/*
This file fetchs data from two different apis:
1. https://covid19.mathdro.id/api
2. https://api.covid19api.com
*/

import axios from 'axios';

const url = "https://covid19.mathdro.id/api";
const url2 = "https://api.covid19api.com";

//fetchs data from url2
export const fetchData = async() => {
    try {
        const response = await axios.get(url2+"/summary");
        return response;
    } catch (error) {
        console.log(error);
        window.location.reload();
    }
}

//fetchs data from url2 for specific countries
export const fetchCountryData = async(country) => {
    try {
        const { data } = await axios.get(url2+"/country/"+country);
        
        const modifiedData = data.map((dailyData) => ({
            confirmed: dailyData.Confirmed,
            deaths: dailyData.Deaths,
            date: dailyData.Date,
            recovered: dailyData.Recovered, 
            active: dailyData.Active
        }))
        return modifiedData;
    } catch (error) {
        console.log(error);
        window.location.reload();
    }
}

//fetchs daily data from url1 to show on line chart
export const fetchDailyData = async () => {
    try {
        const { data } = await axios.get(url+"/daily");

        const modifiedData = data.map((dailyData) => ({
            confirmed: dailyData.confirmed.total,
            deaths: dailyData.deaths.total,
            date: dailyData.reportDate,
        }))

        return modifiedData;
    } catch (error) {
        console.log(error);
        window.location.reload();
    }
}

//Fetchs countru names to show on country picker
export const fetchCountries = async() => {
    try {
        const response = await axios.get(url2+"/summary");
        
        return response.data.Countries.map((country) => country.Country);
    } catch (error) {
        console.log(error);
        window.location.reload();
    }
}